import React from 'react';
import styled from 'styled-components';
import { Wallet } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import TabContainer from '../components/TabContainer';
import GeneralExpensesTab from '../components/payments/GeneralExpensesTab';
import DiscountsTab from '../components/payments/DiscountsTab';
import TithesTab from '../components/payments/TithesTab';

const PageContainer = styled.div`
  padding: 24px;
  max-width: 1400px;
  margin: 0 auto;
  direction: rtl;
  background: white;
  min-height: 100vh;
`;

const PageHeader = styled.div`
  margin-bottom: 24px;
`;

const PageTitle = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
`;

/**
 * הגדרת טאב במודול ניהול התשלומים.
 * visible - האם הטאב מוצג למשתמש הנוכחי, מחושב מיכולות (Capabilities).
 */
interface PaymentsTabConfig {
  key: string;
  title: string;
  visible: boolean;
  render: React.ReactNode;
}

const PaymentsManagementPage: React.FC = () => {
  const { canViewFinancialReports } = useAuth();

  const tabs: PaymentsTabConfig[] = [
    {
      key: 'general-expenses',
      title: 'הוצאות כלליות',
      visible: canViewFinancialReports,
      render: <GeneralExpensesTab />,
    },
    {
      key: 'discounts',
      title: 'הנחות',
      visible: canViewFinancialReports,
      render: <DiscountsTab />,
    },
    {
      key: 'tithes',
      title: 'מעשרות',
      visible: canViewFinancialReports,
      render: <TithesTab />,
    },
  ];

  const visibleTabs = tabs
    .filter(tab => tab.visible)
    .map(tab => ({ key: tab.key, title: tab.title, content: tab.render }));

  return (
    <PageContainer>
      <PageHeader>
        <PageTitle>
          <Wallet size={28} />
          ניהול תשלומים
        </PageTitle>
      </PageHeader>

      {visibleTabs.length > 0 ? (
        <TabContainer tabs={visibleTabs} />
      ) : (
        <p>אין לך הרשאה לצפות בתוכן זה.</p>
      )}
    </PageContainer>
  );
};

export default PaymentsManagementPage;
